import { interfaces } from '@daas-consulting/core-cross-interfaces';
import { getRandom } from '../crypto';
import { serializeToUrl } from '../serialize';

export function getQueryStringFromFilters(filters: interfaces.Criteria[]) {
  const aux: string[] = [];
  const rnd = getRandom();
  aux.push(`nc=${rnd}`);
  if (Array.isArray(filters) && filters.length > 0) {
    filters.forEach((filter) => {
      if (filter?.attributes?.length) {
        filter.attributes.forEach((attr) => {
          const value = serializeToUrl(attr.rawValue);
          aux.push(attr.key, value);
        });
      } else {
        const value = serializeToUrl(filter.rawValue);
        aux.push(filter.key, value);
      }
    });
  }

  const qs = aux.join('&');
  return qs;
}
